import React from 'react';
import logo from './assets/images/websiteLogo.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState } from "react";


const Header = ({ bgImage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const navigate = useNavigate();
  let authentication = localStorage.getItem("token");
  return (
    <div
      className={`${pathname === "/" ? "bg-transparent" : "headerGradient"
        } h-[80px] sm:h-[100px] md:h-[120px] py-[20px] sm:py-[30px] md:py-[35px] relative z-10`}
    >
      <div className="container mx-auto flex justify-between items-center px-4 sm:px-6 lg:px-8">

        {/* Logo */}
        <div
          className="font-semibold flex items-center gap-2 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img src={logo} alt="Logo" className="w-[150px] sm:w-[180px] md:w-[200px]" />
        </div>

        {/* Hamburger Menu for Mobile */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? "✖" : "☰"}
          </button>
        </div>

        {/* Navigation Links */}
        <div
          className={`absolute md:static top-[80px] left-0 w-full md:w-auto bg-white md:bg-transparent shadow-md md:shadow-none transition-transform ${isOpen ? "translate-x-0" : "-translate-x-full md:translate-x-0"
            } md:flex md:items-center`}
        >
          <nav>
            <ul className="flex flex-col md:flex-row items-center gap-6 md:gap-10 font-medium p-6 md:p-0">
              <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
              <li>About Us</li>
              <Link to="/membership" onClick={() => setIsOpen(false)}>Membership</Link>
              <Link to="/contact_us" onClick={() => setIsOpen(false)}>Contact Us</Link>
            </ul>
          </nav>
        </div>

        {/* Authentication Buttons */}
        <div className="hidden md:flex font-medium gap-4 sm:gap-6">
          {!authentication ? (
            <>
              <button onClick={() => navigate("/login")}>Sign in</button>
              <button
                className="rounded-lg darkBlue text-white px-6 sm:px-8 py-2"
                onClick={() => navigate("/register")}
              >
                Sign Up
              </button>
            </>
          ) : (
            <button
              className="rounded-lg darkBlue text-white px-6 sm:px-8 py-2"
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
            >
              Log Out
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
